import { STORAGE_KEYS } from './constants'

/**
 * Limpa todos os dados de autenticação do localStorage
 */
export function clearAuthStorage(): void {
  Object.values(STORAGE_KEYS).forEach((key) => {
    localStorage.removeItem(key)
  })
}

/**
 * Salva múltiplos dados no localStorage
 */
export function saveToStorage(data: Record<string, string>): void {
  Object.entries(data).forEach(([key, value]) => {
    localStorage.setItem(key, value)
  })
}

/**
 * Recupera um valor do localStorage
 */
export function getFromStorage(key: string): string | null {
  return localStorage.getItem(key)
}

/**
 * Recupera e parseia um JSON do localStorage
 */
export function getJsonFromStorage<T = any>(key: string): T | null {
  const value = localStorage.getItem(key)
  if (!value) return null

  try {
    return JSON.parse(value) as T
  } catch {
    return null
  }
}

/**
 * Verifica se o token ainda é válido
 */
export function isTokenValid(): boolean {
  const expiresIn = localStorage.getItem(STORAGE_KEYS.EXPIRES_IN)
  if (!expiresIn) return false

  const tokenExpiry = parseInt(expiresIn, 10)
  return tokenExpiry > Date.now()
}

/**
 * Recupera todos os dados armazenados do usuário
 */
export function getStoredUserData() {
  return {
    token: getFromStorage(STORAGE_KEYS.TOKEN),
    refreshToken: getFromStorage(STORAGE_KEYS.REFRESH_TOKEN),
    user: getJsonFromStorage<string>(STORAGE_KEYS.USER),
    idFazenda: getFromStorage(STORAGE_KEYS.ID_FAZENDA),
    nameUserLogged: getFromStorage(STORAGE_KEYS.NAME_USER_LOGGED),
    profileUserLogged: getFromStorage(STORAGE_KEYS.PROFILE_USER_LOGGED),
    phoneIsConfirmed: getFromStorage(STORAGE_KEYS.PHONE_IS_CONFIRMED),
    emailIsConfirmed: getFromStorage(STORAGE_KEYS.EMAIL_IS_CONFIRMED),
    expiresIn: getFromStorage(STORAGE_KEYS.EXPIRES_IN)
  }
}

/**
 * Calcula o timestamp de expiração do token
 */
export function calculateTokenExpiry(expiresInSeconds: string | number): number {
  const seconds = typeof expiresInSeconds === 'string' ? parseInt(expiresInSeconds, 10) : expiresInSeconds
  return Date.now() + seconds * 1000
}
